import { API_URL_WHALESHARK_PARTNER } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteItem = (uuid: string) =>
  apiInstance({
    url: API_URL_WHALESHARK_PARTNER + uuid,
    method: "delete",
  });

export default deleteItem;
